/* global FWP */
/**
 * Determine if *any* FacetWP facet is active
 *
 * @return {array} Array of active facets
 */
export const getActiveFacets = () => {
	const activeFacets = []

	if( 'object' === typeof FWP?.facets ) {
		const { facets } = FWP

		for( const [ key, selectedValues ] of Object.entries( facets ) ) {
			// if( 'string' === typeof selectedValues && selectedValues.length ) {
			// 	activeFacets.push( key )
			// } else if( Array.isArray( selectedValues ) && selectedValues.length ) {
			// 	activeFacets.push( key )
			// }

			if( selectedValues.length ) {
				activeFacets.push( key )
			}
		}
	}

	return activeFacets
}